import React, {useState, useContext} from 'react'
import {Modal} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faInfo} from '@fortawesome/free-solid-svg-icons'
import getCookie from '../../../../partials/cookie';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css'
import { useEffect } from 'react';
import { Errors } from '../../../../partials/Partials';
import { LoadingContext, EditedContext } from '../../../../partials/Context';


function PhotoModal({show, setShow, setErrors}) {
    const [image_url, setImageUrl] = useState('');
    const [crop, setCrop] = useState({})
    const [error, setError] = useState([])
    const csrftoken = getCookie('csrftoken')
    const {setLoading} = useContext(LoadingContext);
    const {getCurrentLawyer, setLawyerData} = useContext(EditedContext);

    const originalImage = new Image();
    originalImage.src = image_url

    function getMeta(url, callback) {
        var img = new Image();
        img.src = url;
        img.onload = function() {callback(this.width, this.height)}
    }

    useEffect(() => {
        clear()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const uploadPhoto = (e) => {
        setLoading(true)
        const file = e.querySelector('#photo').files[0]
        let formData = new FormData()
        formData.append('photo', file);
        
        fetch('/prawnik/edycja/zdjecie/upload/', {
            method:'POST',
            headers: {
                "X-CSRFToken": csrftoken
            },
            body: formData
        }
        ).then(res => {
            if (res.ok) {
                let newImage = new Image()
                res.json().then(data => {
                    newImage.src = data.url
                    setImageUrl(data.url)
                    getMeta(data.url, function(width, height) {
                        if (height > width) {
                            setCrop({
                                unit: 'px', // Can be 'px' or '%'
                                x: 0,
                                y: 0,
                                width: 180,
                                height: 180
                            })
                        } else {
                            const scale = 180/width
                            setCrop({
                                unit: 'px', // Can be 'px' or '%'
                                x: 0,
                                y: 0,
                                width: height*scale,
                                height: height*scale
                            })
                        }
                    })
                    setLoading(false)
                    setError([]);

            })
            } else {
                setError(['Nie udało się załadować zdjęcia'])
                setLoading(false)
            }

        })
    }


    const cropImage = () => {
        setLoading(true)
        const originalWidth = originalImage.naturalWidth
        const originalSmallerWidth = 180
        const scale = originalWidth/originalSmallerWidth;

        const coordsFormData = new FormData()
        coordsFormData.append('coords[x]', crop.x * scale)
        coordsFormData.append('coords[y]', crop.y * scale)
        coordsFormData.append('coords[x2]', crop.x * scale + crop.width * scale)
        coordsFormData.append('coords[y2]', crop.y * scale + crop.height * scale)

        fetch('/prawnik/edycja/zdjecie/przytnij/', {
            method:'POST',
            headers: {
                "X-CSRFToken": csrftoken
            },
            body: coordsFormData
        }).then(res => {
            if (res.ok) {
                clear()
                getCurrentLawyer(setLawyerData, setErrors)
                setLoading(false)
                setError([])
            } else {
                setError(['Nie udało się przyciąć zdjęcia'])
                setLoading(false)
            }

        })
    };

    const clear = () => {
        setImageUrl('')
        setShow(false)
        setError([]);
        setLoading(false)
    }

    const {unit} = crop || ''
  return (
    <Modal show={show}  onHide={() => {setShow(false); setError([])}}  id="photo-modal">
        <Modal.Header closeButton>
            <Modal.Title>
                <FontAwesomeIcon icon={faInfo} className='fa-info'/>
                Edycja zdjęcia
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Errors errors={error} />
            {!(image_url && unit) ?
            <div className="col-sm-6">
                <form enctype="multipart/form-data" onSubmit={(e) => uploadPhoto(e)}>
                <p>Klienci częściej kontaktują się z prawnikami, którzy mają ładne zdjęcie profilowe</p>
                <label for="photo" id="add-photo">Dodaj zdjęcie</label>
                <input id="photo" type="file" onChange={(e) => uploadPhoto(e.target.parentNode)}/>
                <span id="add-photo-later"onClick={() => setShow(false)}>Dodaj zdjęcie później</span>
                <p className="small-bottom">*W formacie JPG lub PNG</p>
                </form>
            </div>
            :
            <>
            <div className="crop">
                <div className="col-sm-4">
                    <ReactCrop aspect={1/1} crop={crop} onChange={c => {setCrop(c)}}>
                    <img src={image_url} alt="" className="image-to-crop"/>
                    </ReactCrop>
                </div>
                <div>
                    <p>Wyskaluj zdjęcie, aby Twoja twarz dobrze się prezentowała na tle konkurencji</p>
                    <button className="save-btn" onClick={()=>cropImage()}>Zapisz</button>
                    <span id="cancel" onClick={()=>clear()}>Anuluj</span>
                </div>
            </div>
            </>
            }
        </Modal.Body>
    </Modal>
  )
}

export default PhotoModal